import React from "react";
import "./Footer.css";

function InfoItem({ label, children }) {
  return (
    <div className="company-footer__item">
      {label && <strong>{label}</strong>}
      <span>{children}</span>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="company-footer">
      <div className="company-footer__container">
        <div className="company-footer__grid">
          {/* Cột trái */}
          <div className="company-footer__col">
            <h3 className="company-footer__title">
              CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ DU LỊCH ÁNH THÁI DƯƠNG
            </h3>

            <a href="/" className="vt-navbar__logo">
              <img
                style={{ width: "80px", height: "80px" }}
                src="/logo.png"
                alt="ruttienthetindung"
              />
            </a>

            <InfoItem label="Mã số thuế:">0309936637</InfoItem>

            <InfoItem label="Hotline:">
              <a href="tel:0867529641">0867 529 641</a>
            </InfoItem>

            <InfoItem label="Email:">
              <a href="mailto:support@phongvu.vn">daicaxomtro2m8@gmail.com</a>
            </InfoItem>

            <div className="company-footer__policy">
              <a href="/privacy">Chính sách bảo mật</a>
            </div>
          </div>

          {/* Cột phải */}
          <div className="company-footer__col">
            <InfoItem label="Địa chỉ trụ sở chính:">
              131 Đường Số 7, Phường Hạnh Thông, TP Hồ Chí Minh, Việt Nam
            </InfoItem>
          </div>
        </div>
      </div>
    </footer>
  );
}
